import axios from "axios";
import { createUrl } from "../common/utils";
import * as CryptoJS from "crypto-js";

const header1 = {
  headers: {
    Authorization: `Bearer ${localStorage.getItem("Token")}`,
  },
};

function decryptWithCryptoJS(txtToDecrypt) {
  const apiKey = process.env.REACT_APP_SESSION_KEY;
  let _key = apiKey;
  return CryptoJS.AES.decrypt(txtToDecrypt, _key).toString(CryptoJS.enc.Utf8);
}

function getDecryptedSessionItem(key) {
  const encryptedValue = sessionStorage.getItem(key);
  return encryptedValue ? decryptWithCryptoJS(encryptedValue) : null;
}

export const getCurrentScans = async (phone, password) => {
  try {
    const url = createUrl("user/login");
    const response = await axios.get(url, header1);
    return response.data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const getReportFormat = async () => {
  try {
    const types = new Map([
      ["alembic", "alembic-offline"],
      ["drl", "drl"],
      ["abbott", "abbott-offline"],
      ["alcon", "alcon-offline"],
      ["zydus", "zydus-offline"],
      ["mankind", "mankind"],
      ["mkparekh", "mkparekh"],
      ["bluecross", "bluecross"],
      ["ajanta", "ajanta"],
      ["troikaa", "troikaa"],
      ["sanofi", "sanofi"],
      ["sun", "sun"],
      ["elan", "elan"],
      ["wallace", "wallace"],
      ["macleods", "macleods"],
      ["torrent", "torrent"],
      ["zuventus", "zuventus"],
      ["fdc", "fdc"],
      ["lupin", "lupin"],
      ["cadila", "cadila"],
      ["micro", "micro"],
      ["alkem", "alkem"],
      ["apex", "apex"],
    ]);

    let type = types.has(getDecryptedSessionItem("reportType"))
      ? types.get(getDecryptedSessionItem("reportType"))
      : "generic-offline";

    const url = createUrl("report/" + type);
    const response = await axios.get(url, header1);
    return response?.data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const getTodaysReport = async (fromDate, toDate) => {
  try {
    // const url = `${sessionStorage["server"]}/report?fromDate=${fromDate}&toDate=${toDate}`;
    const url = `${getDecryptedSessionItem(
      "server"
    )}/report?fromDate=${fromDate}&toDate=${toDate}`;
    const response = await axios.get(url, {
      verified: true,
      fromDate,
      toDate,
      ...header1,
    });
    // console.log(999999999, { verified: true, fromDate, toDate, ...header1 });

    return response.data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const getMyScansReport = async () => {
  try {
    const url = createUrl("transaction/myscans-web");
    const response = await axios.post(url, { verified: true, ...header1 });
    return response.data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const updateExe = async (exe_url) => {
  try {
    const url = `${getDecryptedSessionItem("server")}/download_and_process_exe`;

    const response = await axios.post(
      url,
      { verified: true, exe_url },
      header1
    );

    return response.data;
  } catch (error) {
    return {
      status: "error",
      error: error.response ? error.response.data : error.message,
    };
  }
};

export const updateTransaction = async (body, transactionId) => {
  try {
    // const url = `${sessionStorage["server"]}/update-transaction`;
    const url = `${getDecryptedSessionItem("server")}/update-transaction`;
    const response = await axios.post(url, body, header1);
    return response.data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const dailyUsageReport = async (startDate, endDate) => {
  try {
    // const url = `${sessionStorage["server"]}/daily-usage?start_date=${startDate}&end_date=${endDate}`;
    const url = `${getDecryptedSessionItem(
      "server"
    )}/daily-usage?start_date=${startDate}&end_date=${endDate}`;
    const response = await axios.get(url, header1);
    return response.data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const updateQuantity = async (body) => {
  try {
    // const url = `${sessionStorage["server"]}/update-quantity`;
    const url = `${getDecryptedSessionItem("server")}/update-quantity`;

    const response = await axios.post(url, body, header1);

    return response.data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const logoutUser = async (header) => {
  try {
    // const url = `${sessionStorage["server"]}/update-category`;
    const url = `${getDecryptedSessionItem("server")}/user/logout`;
    // console.log(header1);
    const response = await axios.post(url, { dsfsf: 1 }, header);
    return response.data;
  } catch (error) {
    console.log(error);
    return { status: "error", error };
  }
};

export const updateRemark = async (existingRemark, newRemark, clientCode) => {
  try {
    const body = {
      existing_remark: existingRemark,
      new_remark: newRemark,
      clientCode: clientCode,
    };

    // const url = `${sessionStorage["server"]}/update-remark`;
    const url = `${getDecryptedSessionItem("server")}/update-remark`;

    const response = await axios.post(url, body, header1);
    return response.data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const updateCategory = async (body) => {
  try {
    // const url = `${sessionStorage["server"]}/update-category`;
    const url = `${getDecryptedSessionItem("server")}/update-category`;

    const response = await axios.post(url, body, header1);
    return response.data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const deleteTransaction = async (id) => {
  try {
    // const url = `${sessionStorage["server"]}/delete-transaction/${id}`;
    const url = `${getDecryptedSessionItem("server")}/delete-transaction/${id}`;

    const response = await axios.delete(url, header1);
    return response.data;
  } catch (error) {
    throw { status: "error", error };
  }
};

export const getUsageCountReport = async (date) => {
  try {
    const response = await axios.get(
      `http://localhost:3333/usage-report-2/${date}`,
      header1
    );
    return response.data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const getAllProducts = async (filters) => {
  try {
    const url = `${getDecryptedSessionItem("server")}/get-all-products`;
    const response = await axios.post(url, { filters }, header1);
    return response.data;
  } catch (error) {
    console.log(error);
    return { status: "error", error };
  }
};

export const resumeScan = async () => {
  try {
    const url = `${getDecryptedSessionItem("server")}/scan/resume`;
    const response = await axios.post(url, {}, header1);
    return response.data;
  } catch (error) {
    return { status: "error", error };
  }
};

